import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";
import { Badge, Button, Icon, Modal } from "../design";

const ConfirmWorkspaceRemovalModal = ({ setOpenDeleteModal, onCloseMain }) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user, loadUserTenant } = useContext(AuthContext);
  const { deleteWorkspace } = useContext(LandLordContext);

  const [buttonDisable, setButtonDisable] = useState(false);

  const workspaceName =
    user?.workspaceIds?.find(
      (val) => val?.uuid?.toString() === workspaceId?.toString()
    )?.name ?? "";

  const handleSubmitButton = () => {
    setButtonDisable(true);
    deleteWorkspace({})
      .then(() => {
        loadUserTenant("landlord");
        navigate("/workspace-dashboard");
        toast.success(_t("workspaceRemovedSuccessfully"));
        onCloseMain();
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileRemovingworkspace"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };

  const close = () => setOpenDeleteModal(false);

  return (
    <Modal
      open
      onClose={close}
      size="sm"
      title={_t("deleteMyWorkspace")}
      description={_t(
        "areYouSureWantToPermanentlyDeleteThisWorkspaceAllSharedProfilesPropertiesAndMembersWillAlsoBeDeleted"
      )}
      actions={
        <>
          <Button
            variant="secondary"
            size="lg"
            onClick={close}
            disabled={buttonDisable}
          >
            {_t("noGoBack")}
          </Button>
          <Button
            variant="danger"
            size="lg"
            onClick={handleSubmitButton}
            loading={buttonDisable}
          >
            {_t("yesRemove")}
          </Button>
        </>
      }
    >
      {workspaceName && (
        <div className="workspace-confirm-person">
          <Badge>
            <Icon name="home" size={14} />
            {workspaceName}
          </Badge>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmWorkspaceRemovalModal;
